module.exports = __webpack_public_path__ + "static/media/iconCongrats.035f6aa2.svg";